import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
  canonical,
}) => {
  const siteTitle = 'Chasing TCG';
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const defaultDescription = 'Professional Pokémon and One Piece TCG collection tracking, market analytics, and restock alerts.';
  const defaultKeywords = 'Pokemon TCG, One Piece TCG, card collection, price tracker, restock alerts, TCG trading, market value';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta property="og:description" content={ogDescription || description || defaultDescription} />
      {ogImage && <meta property="og:image" content={ogImage} />}

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={ogTitle || fullTitle} />
      <meta property="twitter:description" content={ogDescription || description || defaultDescription} />
      {ogImage && <meta property="twitter:image" content={ogImage} />}

      {/* Canonical Link */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* AdSense Requirements (Robots) */}
      <meta name="robots" content="index, follow" />
    </Helmet>
  );
};

export default SEO;
